import * as yup from "yup";
import { fetchData } from "@utils/api";
import { APIMethods } from "@typeDefinitions";

export interface FetchUnpaidInvoicesCountResponse {
  count: number;
}

export const fetchUnpaidInvoicesCount =
  async (): Promise<FetchUnpaidInvoicesCountResponse> => {
    const response = await fetchData(
      "/dietitian/invoices/unpaid/count",
      APIMethods.GET,
    );
    return schema.validate(response);
  };

const schema = yup.object({
  count: yup.number().required(),
});
